import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Grid,
  CardContent,
  Typography,
  Divider,
  Switch,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Stack,
  Paper,
  CircularProgress,
  Select,
  MenuItem,
  Radio,
  FormLabel,
  Autocomplete,
  Checkbox,
  ListItemText,
  FormControlLabel,
  FormControl,
  RadioGroup,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import api from "../../utils/Url";
import Box from "@mui/material/Box";

import { toast } from "react-toastify";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
} from "@react-google-maps/api";
import CustomLabel from "../../CustomLable";
import { useFormik } from "formik";
import PrintIcon from "@mui/icons-material/Print";
import dustIcon from "../../assets/images/kudaghr.png";
import { styled } from "@mui/system";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  padding: theme.spacing(2),
  borderRadius: "8px",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  backgroundColor: "#e3e3e3", // Optional: set a background color
}));

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}

export default function Kudaghar() {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const [option, setOption] = useState([
    { value: "-1", label: "Select Ward Wise" },
  ]);

  const [selectedValue, setSelectedValue] = useState("1");

  const [isVisible, setVisible] = useState<any>(false);

  const [isVisible1, setVisible1] = useState<any>(false);

  const [isVisible2, setVisible2] = useState<any>(false);

  const [isVisible3, setVisible3] = useState<any>(false);

  const [isAllBins, setAllBins] = useState<any>();

  useEffect(() => {
    getWard();
   // setVisible1(true);
   // setVisible1(true);
    getAllData();
    handleAll();
    setVisible3(false)
  }, []);

  const [vehicles, setVehicles] = useState<any>([]);

  const [vehicles1, setVehicles1] = useState<any>([]);
  const [activeVehicle, setActiveVehicle] = useState<any>(null);

  const [activeVehicle1, setActiveVehicle1] = useState<any>(null);

  
  const mapRef: any = useRef(null);

  const getWardMap = (data: any) => {
    const collectData = {
      where: data?.label,
      orderby: "",
      pageNo: 0,
      pageSize: 0,
      intnotnullvalue1: 0,
      userId: "string",
      parameterValues: [data?.value, data?.label],
      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      date1: new Date().toISOString(),
      date2: new Date().toISOString(),
      date3: new Date().toISOString(),
      date4: new Date().toISOString(),
      dec1: 0,
      dec2: 0,
      dec3: 0,
      dec4: 0,
      flag: true,
      data: "",
      success: true,
      error: "",
      selectPerindex: 0,
      show: true,
    };

    api.post(`Dashboard/GetMapBinsWardWise`, collectData).then((res) => {
      const data = res?.data?.data;

      const arr = data.map((item: any) => ({
        // vehicleNo: item.vehicleno || "No ID",
        lat: item.latitude,
        lng: item.longitude,
        id: item.binLocID,
        binLocName: item.binLocName,

        binLocID: item.binLocID,

        icon: "https://png.pngtree.com/png-vector/20240202/ourmid/pngtree-green-wheelie-bin-clip-art-png-image_11591537.png",
      }));
      setVehicles1(arr);
      fetchZonesData(data);
     // setCenter(calculateCenter(arr));
      setVisible3(true);

      if (arr.length > 0) {
       // adjustZoomLevel(arr);
      }
    });
  };

  // Fetch the vehicle data from API
  const getAllData = () => {
    const collectData = {
      orderby: "",
      pageNo: 0,
      pageSize: 0,
      intnotnullvalue1: 0,
      userId: "",

      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      date1: new Date().toISOString(),
      date2: new Date().toISOString(),
      date3: new Date().toISOString(),
      date4: new Date().toISOString(),
      dec1: 0,
      dec2: 0,
      dec3: 0,
      dec4: 0,
      flag: false,
      data: "",
      success: true,
      error: "",
      selectPerindex: 0,
      show: true,
    };

    api
      .post(`Dashboard/GetAllBins`, collectData)
      .then((res) => {
        if (res?.data) {
          const allBin = res?.data?.rowCount;
          const data = res?.data?.data;

          if (data && data.length > 0) {
            setAllBins(allBin);
            const arr = data.map((item: any) => ({
              lat: item.latitude,
              lng: item.longitude,
              id: item.binLocID,
              binLocName: item.locationName,
              binLocID: item.binLocID,
              icon: "https://png.pngtree.com/png-vector/20240202/ourmid/pngtree-green-wheelie-bin-clip-art-png-image_11591537.png",
            }));

            setVehicles(arr);
            fetchZonesData(data);
         
            setVisible2(true);

           
          } else {
            console.error("No bin data found.");
          }
        } else {
          console.error(
            "API request failed:",
            res?.data?.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching bin data:", error);
      });
  };

 
  const handleMarkerMouseOver = (vehicle: any) => {
    setActiveVehicle(vehicle);
  };

  const handleMarkerMouseOut = () => {
    setActiveVehicle(null);
  };

  const handleMarkerMouseOver1 = (vehicle: any) => {
    setActiveVehicle1(vehicle);
  };

  const handleMarkerMouseOut1 = () => {
    setActiveVehicle1(null);
  };

  const getWard = () => {
    const collectData = {
      where: "",
      orderby: "",
      pageNo: 0,
      pageSize: 0,
      intnotnullvalue1: 0,
      userId: "",
      parameterValues: [""],
      str1: "",
      str2: "",
      str3: "",
      str4: "",
      str5: "",
      intvalue1: 0,
      intvalue2: 0,
      intvalue3: 0,
      intvalue4: 0,
      intnotnullvalue2: 0,
      intnotnullvalue3: 0,
      date1: "2024-12-12T10:30:03.126Z",
      date2: "2024-12-12T10:30:03.126Z",
      date3: "2024-12-12T10:30:03.126Z",
      date4: "2024-12-12T10:30:03.126Z",
      dec1: 0,
      dec2: 0,
      dec3: 0,
      dec4: 0,
      flag: true,
      data: "",
      success: true,
      error: "",
      selectPerindex: 0,
      show: true,
    };

    api.post(`AreaWardMaster/GetAreaWardMaster`, collectData).then((res) => {
      const arr = [];
      console.log("result" + JSON.stringify(res.data.data));
      for (let index = 0; index < res.data.data.length; index++) {
        arr.push({
          label: res?.data?.data[index]["areaName"],
          value: res?.data?.data[index]["areaID"],
        });
      }
      setOption(arr);
    });
  };

  const handleWard = () => {
    setVisible(true);
    setVisible1(false);
  };

  const handleAll = () => {
    setVisible1(true);
    setVisible(false);
  };


  

 

  const formik = useFormik({
    initialValues: {
      genderID: -1,
      genderName: "",
      genderCode: "",
    },
    onSubmit: async (values) => {
      //   const response = await api.post(
      //     `Gender/AddUpdateGenderMaster`,
      //     values
      //   );
      //   try {
      //     setToaster(false);
      //     toast.success(response.data.mesg);
      //     navigate("/master/GenderMaster");
      //   } catch (error) {
      //     setToaster(true);
      //     toast.error(response.data.mesg);
      //   }
    },
  });

  const fetchZonesData = async (data: any) => {
    try {
      // const collectData = {};
      // const response = await api.post(
      //   `api/Transaction/MembBalanceHourData`,
      //   collectData
      // );
      // const data = response?.data?.data?.vBookIssdRec;

      // console.log("HourData", data);
      const zonesWithIds = data?.map((zone: any, index: any) => ({
        ...zone,
        serialNo: index + 1,
        id: index + 1,
      }));
      setZones(zonesWithIds);

      // setSelectedRows(zonesWithIds.map((zone: any) => zone.id));
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 0.5,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "binLocName",
            headerName: t("text.BinLocation"),
            flex: 1,
            // headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "locationName",
            headerName: t("text.Location"),
            flex: 3,
            // headerClassName: "MuiDataGrid-colCell",
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  return (
    <div>
      <Grid item xs={12} container spacing={2} >
        <Grid item xs={12} sm={5} lg={5}>
          <StyledRadioGroup
            value={selectedValue}
            onChange={(e) => setSelectedValue(e.target.value)}
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="All Kudaghar"
              onChange={() => {
                handleAll();
                getAllData();

                setVisible3(false);
              }}
            />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Wardwise Kudaghar"
              onChange={handleWard}
            />
          </StyledRadioGroup>
        </Grid>
        {isVisible1 && (
          <Grid item xs={12} sm={3} lg={3} sx={{ marginTop: ".5%" }}>
            <StyledRadioGroup>
              <img
                src={dustIcon}
                style={{ width: "24px", height: "24px", marginRight: "8px" }}
              />
              <Typography sx={{ color: "black", fontSize: 15 }}>
                Total Kudaghar : {""} {isAllBins}
              </Typography>
            </StyledRadioGroup>
          </Grid>
        )}

        {isVisible && (
          <Grid item xs={12} sm={6} lg={6}>
            <StyledRadioGroup>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={option}
                fullWidth
                size="small"
                onChange={(event, newValue: any) => {
                  // console.log(newValue?.value);
                  formik.setFieldValue("parentName", newValue?.label);
                  formik.setFieldValue("parentId", newValue?.value);

                  getWardMap(newValue);

                  setVisible2(false);
                }}
                style={{ backgroundColor: "#ffff" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<CustomLabel text="Select Ward Wise" />}
                  />
                )}
              />
            </StyledRadioGroup>
          </Grid>
        )}
      </Grid>

      <Grid
  container
  spacing={2}
  style={{
    marginTop: "1vh",
  }}
>
  {/* First map condition */}
  {isVisible2 && (
    <Grid item xs={12} sm={12} lg={12}>
      <div
        style={{
          border: "1px solid black",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={{ lat: 26.447965, lng: 80.3432 }}
          zoom={12}
          onLoad={(map: any) => (mapRef.current = map)}
        >
          {vehicles?.map((vehicle: any) => (
            <Marker
              key={vehicle.id}
              position={{ lat: vehicle.lat, lng: vehicle.lng }}
              icon={{
                url: vehicle.icon,
                scaledSize: new window.google.maps.Size(50, 50),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(25, 25),
              }}
              onMouseOver={() => handleMarkerMouseOver(vehicle)}
              onMouseOut={handleMarkerMouseOut}
            >
              {activeVehicle && activeVehicle.id === vehicle.id && (
                <InfoWindow>
                  <div>
                    <div>
                      <strong>Bin Location </strong>
                      {vehicle.binLocName}
                    </div>
                  </div>
                </InfoWindow>
              )}
            </Marker>
          ))}
        </GoogleMap>
      </div>
    </Grid>
  )}

  {/* Second map condition */}
  {isVisible3 && (
    <Grid item xs={12} sm={12} lg={12}>
      <div
        style={{
          border: "1px solid black",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        }}
      >
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={{ lat: 26.447965, lng: 80.3432 }}
          zoom={12}
          onLoad={(map: any) => (mapRef.current = map)}
        >
          {vehicles1.map((vehicle: any) => (
            <Marker
              key={vehicle.id}
              position={{ lat: vehicle.lat, lng: vehicle.lng }}
              icon={{
                url: vehicle.icon,
                scaledSize: new window.google.maps.Size(50, 50),
                origin: new window.google.maps.Point(0, 0),
                anchor: new window.google.maps.Point(25, 25),
              }}
              onMouseOver={() => handleMarkerMouseOver1(vehicle)}
              onMouseOut={handleMarkerMouseOut1}
            >
              {activeVehicle1 && activeVehicle1.id === vehicle.id && (
                <InfoWindow>
                  <div>
                    <div>
                      <strong>Bin Location </strong>
                      {vehicle.binLocName}
                    </div>
                  </div>
                </InfoWindow>
              )}
            </Marker>
          ))}
        </GoogleMap>
      </div>
    </Grid>
  )}
</Grid>

      <form onSubmit={formik.handleSubmit}>
        <Grid item xs={12} container spacing={2} sx={{ marginTop: "3%" }}>
          <Grid item xs={12} sm={1} lg={1}>
            <PrintIcon fontSize="large" sx={{ color: "blue" }} />
          </Grid>

          <Grid item xs={12} sm={3} lg={3}>
            <FormControl component="fieldset">
              <RadioGroup row>
                <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
                <FormControlLabel
                  value="excel"
                  control={<Radio />}
                  label="Excel"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          <Grid xs={12} sm={12} md={12} item sx={{ marginTop: "3%" }}>
            <DataGrid
              rows={zones}
              columns={adjustedColumns}
              rowSpacingType="border"
              autoHeight
              // slots={{
              //   toolbar: GridToolbar,
              // }}
              pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                value: size,
                label: `${size}`,
              }))}
              initialState={{
                pagination: { paginationModel: { pageSize: 5 } },
              }}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
              sx={{
                border: 0,
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#42b6f5", // Header background color
                  color: "white", // Header text color
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white", // Header title text color
                },
              }}
            />
          </Grid>
        </Grid>
      </form>
    </div>
  );
}
